export default {
  EmailField: 'login-page__email-field',
  PasswordField: 'login-page__password-field',
  LoginButton: 'login-page__login-button',
  ForgotPasswordLink: 'login-page__forgot-password-link',
  PrivacyPolicyButton: 'login-page__privacy-policy',
  TermsAndConditionsButton: 'login-page__terms-and-conditions'
};
